import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ProjectBudgetSynthesis, Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  hasRetrievedSynthesis: boolean;
  synthesis: ProjectBudgetSynthesis;
  retrieveProjectBudgetSynthesis(
    request: Boundaries["retrieveProjectBudgetSynthesis"]["request"],
  ): void;
}

function useRetrieveProjectBudgetSynthesis(
  project: Identifiable<Project>,
  date: string,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectBudgetSynthesisRequestPending(project, date),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectBudgetSynthesisRequestSuccess(project, date),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectBudgetSynthesisRequestFailure(project, date),
    ),
    hasRetrievedSynthesis: useSelector(() =>
      selector.hasRetrievedProjectBudgetSynthesis(project, date),
    ),
    synthesis: useSelector(() =>
      selector.getProjectBudgetSynthesis(project, date),
    ),
    retrieveProjectBudgetSynthesis: core.retrieveProjectBudgetSynthesis,
  };
}

export { useRetrieveProjectBudgetSynthesis };
